var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('van-loading',{attrs:{"type":"spinner","vertical":""}},[_vm._v("登录中...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }